export default __webpack_public_path__ + "static/media/medicare_b.cab0059f.png";